import { useEffect, useState } from "react";
import { getOnboardingSteps } from "../utils/getOnboardingSteps";
import { getLine3Nodes } from "../utils/getLine3Nodes";
import { getLineNodesGrid } from "../utils/getLineNodesGrid";
import { styleNodes } from "../utils/styleNodes";
import { setNodesPosition } from "../utils/setNodesPosition";
import { MarkerType } from "@xyflow/react";
import {
  initialNodesData,
  initialEdgesData,
  line3Conditions,
} from "../const/data";

export const useDiagramData = () => {
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const hasOnboarding = searchParams.get("hasOnboarding");
    const solutionName = searchParams.get("solutionName")?.split("?")[0];

    const color1 = `#${searchParams.get("color1") || "000000"}`;
    const color2 = `#${searchParams.get("color2") || "ffffff"}`;

    let filteredNodes = [];

    if (hasOnboarding === "T") {
      filteredNodes = getOnboardingSteps(searchParams, initialNodesData);
    }

    if (solutionName) {
      const line2Node = initialNodesData.find((node) => node.line === 2);
      if (line2Node) {
        line2Node.data.label = `${solutionName} Experience`;
        filteredNodes.push(line2Node);
      }
    }

    const nodeGrid = getLineNodesGrid(3, initialNodesData);

    const items = getLine3Nodes(
      searchParams,
      initialNodesData,
      line3Conditions
    );

    nodeGrid.data.items = items;

    filteredNodes = [...filteredNodes, nodeGrid];
    filteredNodes = styleNodes(filteredNodes, color1, color2);

    const positionedNodes = filteredNodes.length
      ? setNodesPosition(filteredNodes)
      : setNodesPosition(initialNodesData);

    setNodes(positionedNodes);

    const solutionsNode = positionedNodes.find(
      (node) => node.id === "SOLUTIONS"
    );

    const line1Nodes = positionedNodes.filter((node) => node.line === 1);
    const lastLine1NodeId =
      line1Nodes.length > 0 ? line1Nodes[line1Nodes.length - 1].id : null;

    const line1Edges = line1Nodes.reduce((acc, curr, index) => {
      if (index < line1Nodes.length - 1) {
        acc.push({
          id: `line1-to-line2-${index}`,
          source: curr.id,
          target: line1Nodes[index + 1].id,
          type: "step",
          style: {
            stroke: color1,
            strokeWidth: 2,
          },
          markerEnd: {
            type: MarkerType.Arrow,
            color: color1,
            width: 15,
            height: 15,
          },
        });
      }
      return acc;
    }, []);

    const line3Edges = {
      id: "e-modules-to-solutions",
      source: "SOLUTIONS",
      target: "MODULES",
      type: "step",
      style: {
        stroke: color1,
        strokeWidth: 2,
      },
    };

    const newEdges = [
      line3Edges,
      ...initialEdgesData.map((edge) => ({
        ...edge,
        style: {
          stroke: color1,
          strokeWidth: 2,
        },
        markerEnd: {
          type: MarkerType.Arrow,
          color: color1,
          width: 15,
          height: 15,
        },
      })),
      ...line1Edges,
      ...(lastLine1NodeId && solutionsNode
        ? [
            {
              id: "line1-to-line2",
              source: lastLine1NodeId,
              target: "SOLUTIONS",
              type: "step",
              style: {
                stroke: color1,
                strokeWidth: 2,
              },
              markerEnd: {
                type: MarkerType.Arrow,
                color: color1,
                width: 15,
                height: 15,
              },
            },
          ]
        : []),
    ];

    setEdges(newEdges);
  }, []);

  return { nodes, edges };
};
